import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import SelectorField from './selector-field';
import 'next/stylesheets/components/form-fields/todo-assignee-select-field.scss';

export default Component('tr-todo-assignee-select-field', {
  extends: [SelectorField],

  mixins: [eventListenerMixin],

  properties: {
    openOnReady: {
      type: Boolean,
      default: false,
    },

    hideResultText: {
      type: Boolean,
      default: false,
    },
  },

  ready() {
    if (this.openOnReady) {
      this.toggleList();
      this.openOnReady = false;
    }
  },

  beforeCache() {
    this.list.close();
    this.openOnReady = false;
  },
});
